
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Login from './Login';
import Register from './Register';
import Dashboard from './Dashboard';
import WheelchairRental from './WheelchairRental';
import StationPlannerPage from './StationPlannerPage';
import LuggageSearch from './components/LuggageSearch';
import Impressum from './Impressum';
import { LanguageProvider } from './i18n/LanguageContext';
import NotificationHost from './ui/NotificationHost';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function App() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Beim App-Start: Prüfen ob User im localStorage gespeichert ist
  useEffect(() => {
    try {
      const savedUser = localStorage.getItem('user');
      if (savedUser) {
        const userData = JSON.parse(savedUser);
        console.log('Benutzer aus localStorage wiederhergestellt:', userData);
        setUser(userData);
      }
    } catch (error) {
      console.error('Fehler beim Laden der gespeicherten Login-Daten:', error);
      // Bei Fehler: localStorage bereinigen
      localStorage.removeItem('user');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handleLogin = (userData) => {
    console.log('Login erfolgreich, speichere Benutzer:', userData);
    setUser(userData);
    // Benutzer persistent im localStorage speichern
    try {
      localStorage.setItem('user', JSON.stringify(userData));
    } catch (error) {
      console.error('Fehler beim Speichern der Login-Daten:', error);
    }
  };

  const handleLogout = () => {
    console.log('Logout - entferne gespeicherte Daten');
    setUser(null);
    // Benutzer + Token aus localStorage entfernen
    try {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    } catch (error) {
      console.error('Fehler beim Entfernen der Login-Daten:', error);
    }
  };

  // Zeige Loading-Screen während der Initialisierung
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Wird geladen...</span>
          </div>
          <div className="mt-2">Lade Anwendung...</div>
        </div>
      </div>
    );
  }

  return (
    <LanguageProvider>
    <NotificationHost />
    <Router>
      <div className="App">
        {/* Einfache Navigation nur für öffentliche Rollstuhlvermietung */}
        {window.location.pathname === '/rollstuhl' && (
          <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
            <div className="container">
              <Link className="navbar-brand" to="/">
                Personalplanung
              </Link>
              <div className="navbar-nav ms-auto">
                <Link className="nav-link" to="/">
                  Zurück zum System
                </Link>
              </div>
            </div>
          </nav>
        )}

        <Routes>
          {/* Öffentliche Route für Rollstuhlvermietung */}
          <Route path="/rollstuhl" element={<WheelchairRental />} />
          
          {/* Öffentliche Route für Gepäckstück-Suche */}
          <Route path="/gepaeck-suchen" element={<LuggageSearch />} />
          
          {/* Öffentliche Route für Bewerber-Registrierung */}
          <Route path="/bewerben" element={<Register />} />
          
          {/* Station Planner Route */}
          <Route path="/station-planner" element={<StationPlannerPage />} />

          {/* Öffentliche Route für Impressum */}
          <Route path="/impressum" element={<Impressum />} />
          
          {/* Hauptseite - zeigt Login oder Dashboard */}
          <Route 
            path="/" 
            element={
              user ? (
                <Dashboard user={user} onLogout={handleLogout} />
              ) : (
                <Login onLogin={handleLogin} />
              )
            } 
          />
          
          {/* Login Route */}
          <Route 
            path="/login" 
            element={
              user ? (
                <Dashboard user={user} onLogout={handleLogout} />
              ) : (
                <Login onLogin={handleLogin} />
              )
            } 
          />
          
          {/* Dashboard Route (nur für angemeldete Benutzer) */}
          <Route 
            path="/dashboard" 
            element={
              user ? (
                <Dashboard user={user} onLogout={handleLogout} />
              ) : (
                <Login onLogin={handleLogin} />
              )
            } 
          />
        </Routes>
      </div>
    </Router>
    </LanguageProvider>
  );
}

export default App;
